import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/var/www/vietthien.com/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vietthien.com/src/app/[locale]/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vietthien.com/src/components/Layouts/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vietthien.com/src/components/Layouts/HeaderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderProvider"] */ "/var/www/vietthien.com/src/context/HeaderLayoutContext.tsx");
